import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { getFilterValues } from '../sbSharedRefineMenuHelpers';

// components
import { SbSharedRefineMenuMultiSelect } from '../SbSharedRefineMenuMultiSelect/SbSharedRefineMenuMultiSelect';
import { SbSharedRefineMenuExpandableItemList } from '../SbSharedRefineMenuExpandableItemList/SbSharedRefineMenuExpandableItemList';

/* eslint-disable react/prop-types, react/display-name */

export const SbSharedRefineMenuMultiSelectListComponent = props => {
    const { values, searchBrowse, filterName, collapsedItemCount } = props;
    const { appliedFilters } = searchBrowse;

    const appliedFilterValues = getFilterValues(appliedFilters, filterName);

    return (
        <SbSharedRefineMenuExpandableItemList
            filterName={filterName}
            availableFilterValues={values}
            collapsedItemCount={collapsedItemCount}
        >
            {({ valuesToShow }) => (
                <SbSharedRefineMenuMultiSelect
                    filterName={filterName}
                    appliedFilterValues={appliedFilterValues}
                    valuesToShow={valuesToShow}
                />
            )}
        </SbSharedRefineMenuExpandableItemList>
    );
};

SbSharedRefineMenuMultiSelectListComponent.propTypes = {
    values: PropTypes.array.isRequired,
    collapsedItemCount: PropTypes.number,
    filterName: PropTypes.string.isRequired,
    searchBrowse: PropTypes.object.isRequired,
};

export const SbSharedRefineMenuMultiSelectList = createFragmentContainer(
    SbSharedRefineMenuMultiSelectListComponent,
    {
        searchBrowse: graphql`
            fragment SbSharedRefineMenuMultiSelectList_searchBrowse on SearchBrowseQueryConnection {
                appliedFilters {
                    name
                    localizedFilterName
                    canBeDismissed
                    values {
                        urlLabel
                        count
                        displayName
                    }
                }
            }
        `,
    }
);
